import React from 'react'
import agent from '../agent'
import TransactionList from './widgets/TransactionList';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import Pager from 'react-pager'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import role from '../util/role'

import {
  TRANSACTION_LIST_PAGE_LOADED,
  TRANSACTION_LIST_SEARCH_LOADED,
  TRANSACTION_LIST_NEXT_PAGE_LOADED,
  TRANSACTION_LIST_PAGE_UNLOADED,
  UPDATE_FIELD_TRANSACTION_LIST_SEARCHTERM,
  CHANGE_DATE_STRINGS,
  TRANSACTION_LIST_EXPORT
} from '../constants/actionTypes'
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

const mapStateToProps = state => ({
  ...state.transaction,
  currentUser: state.common.currentUser,
  appName: state.common.appName,
  token: state.common.token,
  date_from: state.common.date_from,
  date_to: state.common.date_to
});

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, pageIndex, tran_type, terms, date_from, date_to) =>
    dispatch({ type: TRANSACTION_LIST_PAGE_LOADED, payload, currentPage: pageIndex, tran_type, searchTerm: terms, date_from, date_to }),
  onLoadNextPage: (payload, pageIndex, tran_type, terms, date_from, date_to) => {
    dispatch({ type: TRANSACTION_LIST_NEXT_PAGE_LOADED, payload, currentPage: pageIndex, tran_type, searchTerm: terms, date_from, date_to })
  },
  onSearchTransactions: (payload, pageIndex, tran_type, terms, date_from, date_to) => {
    dispatch({ type: TRANSACTION_LIST_SEARCH_LOADED, payload, currentPage: pageIndex, tran_type, searchTerm: terms, date_from, date_to })
  },
  onChangeSearchTerm: value =>
    dispatch({ type: UPDATE_FIELD_TRANSACTION_LIST_SEARCHTERM, key: 'searchTerm', value }),
  onChangeDateStrings: (date_from, date_to) =>
    dispatch({ type: CHANGE_DATE_STRINGS, date_from, date_to }),
  onUnload: () =>
    dispatch({ type: TRANSACTION_LIST_PAGE_UNLOADED }),
  onExportCsv: (payload) =>
    dispatch({ type: TRANSACTION_LIST_EXPORT, payload }),
});

class Transactions extends React.Component {
  constructor() {
    super()
    this.handleAllSelected = this.handleChangeTransactionType.bind(this, '')
    this.handleEthCommitSelected = this.handleChangeTransactionType.bind(this, 'ethcommit')
    this.handleBtcCommitSelected = this.handleChangeTransactionType.bind(this, 'btccommit')

    this.changeSearchTerm = (ev) => this.props.onChangeSearchTerm(ev.target.value)
    this.search = () => ev => {
      ev.preventDefault()
      const pageIndex = 1;
      const tran_type = this.props.tran_type || 'all'
      const terms = this.props.searchTerm || ''
      const date_from = this.props.date_from || ''
      const date_to = this.props.date_to || ''
      const payload = agent.Transactions.all(pageIndex, tran_type, terms, date_from, date_to)
      this.props.onSearchTransactions(payload, pageIndex, tran_type, terms, date_from, date_to)
    }
    this.exportCsv = () => ev => {
      ev.preventDefault()
      this.props.onExportCsv(agent.Transactions.export())
    }
  }
  componentWillMount() {
    const pageIndex = 1;
    const tran_type = 'all'
    const terms = ''
    const date_from = ''
    const date_to = ''
    const payload = agent.Transactions.all(pageIndex, tran_type, terms, date_from, date_to)
    this.props.onLoad(payload, pageIndex, tran_type, terms, date_from, date_to);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.csvData) {
      var data = new Blob([nextProps.csvData], { type: 'text/csv' });
      var csvURL = window.URL.createObjectURL(data);
      var tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', `${new Date()}_transactions.csv`);
      tempLink.click();
    }
  }
  componentWillUnmount() {
    this.props.onUnload();
  }
  handlePageChanged(newPage) {
    const pageIndex = newPage + 1;
    const tran_type = this.props.tran_type || 'all'
    const terms = this.props.searchTerm || ''
    const date_from = this.props.date_from || ''
    const date_to = this.props.date_to || ''
    const payload = agent.Transactions.all(pageIndex, tran_type, terms, date_from, date_to)
    this.props.onLoadNextPage(payload, pageIndex, tran_type, terms, date_from, date_to);
  }
  handleChangeTransactionType(transactionType) {
    const pageIndex = 1;
    const tran_type = transactionType || 'all'
    const terms = this.props.searchTerm || ''
    const date_from = this.props.date_from || ''
    const date_to = this.props.date_to || ''
    const payload = agent.Transactions.all(pageIndex, tran_type, terms, date_from, date_to)
    this.props.onLoad(payload, pageIndex, tran_type, terms, date_from, date_to);
  }
  handleChangeDateStrings(dates, dateStrings) {
    var unixFrom = dateStrings[0] ? moment(dateStrings[0]).format('X') : ''
    var unixTo = dateStrings[1] ? moment(moment(dateStrings[1]).format('YYYY-MM-DD 23:59:59')).format('X') : ''
    this.props.onChangeDateStrings(unixFrom, unixTo)
  }
  render() {
    const current = this.props.currentPage - 1
    const date_from = this.props.date_from ? moment(moment(this.props.date_from * 1000).format('YYYY-MM-DD')) : ''
    const date_to = this.props.date_to ? moment(moment(this.props.date_to * 1000).format('YYYY-MM-DD')) : ''

    return (
      <div class='pane'>
        {role.can(this.props.currentUser.role, TRANSACTION_LIST_EXPORT) ?
          <span><Link className="buttonTop" to='#'><i className="icon ion-ios-download-outline" onClick={this.exportCsv()} ></i></Link></span>
          : null}
        <h1>Transactions list</h1>
        <div className="filters">
          <div className="filterTabs">
            <Link to='/transactions' className={this.props.tran_type === 'all' ? "selected" : ""} onClick={this.handleAllSelected}>All</Link>
          </div>
          <div className="filterSearch">
            <RangePicker
              ranges={{ 'This Month': [moment().startOf('month'), moment()], Today: [moment(), moment()] }}
              value={[date_from, date_to]}
              onChange={this.handleChangeDateStrings.bind(this)}
            />
            <input type="text" placeholder="find by key" value={this.props.searchTerm} onChange={this.changeSearchTerm} />
            <button type="submit" onClick={this.search()}>Find</button>
          </div>
        </div>
        <TransactionList transactions={this.props.transactions} loading={this.props.loading} />
        {
          this.props.transactions && this.props.transactions.length > 0 ?
            <Pager
              total={this.props.totalPage || 0}
              current={this.props.currentPage - 1}
              visiblePages={7}
              titles={{ first: '<<', last: '>>' }}
              onPageChanged={this.handlePageChanged.bind(this)}
            />
            : null
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);



// WEBPACK FOOTER //
// ./src/components/Transactions.js